import { Box, styled } from '@mui/material';
import React from 'react';
import type { FC, PropsWithChildren } from 'react';

const CustomBox = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  overflowY: 'auto',
}));

const ModalContentWrapper: FC<PropsWithChildren> = ({ children, ...props }) => {
  return <CustomBox {...props}>{children}</CustomBox>;
};

export default ModalContentWrapper;
